{
    "title": "Snapshot Date",
    "description": "Date of data refresh",
    "type": "string",
    "required": true,
    "key": true
}
